// Polyfills for Redux DevTools compatibility
// Simple Symbol.observable polyfill to prevent Redux DevTools warning
if (typeof Symbol !== 'undefined' && !Symbol.observable) {
    Symbol.observable = Symbol('observable');
}
